/* src/app/components/lead-details/participant-information/lead-detail-parent-guardian/lead-detail-parent-guardian.component.css */
.custom-row {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.pg-dialog-body {
  max-width: 56rem;
}
/*# sourceMappingURL=lead-detail-parent-guardian.component-LW74GMTQ.css.map */
